import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'wings-chat-header',
  standalone: false,
  templateUrl: 'wings-chat-header.html',
  styleUrls: ['wings-chat-header.scss']
})
export class WingsChatHeaderComponent {
  @Input() isMinimized: boolean = false;
  @Input() isFullscreen: boolean = false;
  @Input() title: string = 'Wings Assistant';

  @Output() toggleMinimized = new EventEmitter<void>();
  @Output() closeChat = new EventEmitter<void>();
  @Output() toggleFullscreen = new EventEmitter<void>();
  @Output() resetSize = new EventEmitter<void>();
  @Output() resizeStart = new EventEmitter<MouseEvent>();

  onToggleMinimized(): void {
    console.log('Header: onToggleMinimized', this.isMinimized);
    this.toggleMinimized.emit();
  }

  onCloseChat(): void {
    this.closeChat.emit();
  }
  
  onToggleFullscreen(): void {
    this.toggleFullscreen.emit();
  }
  
  onResetSize(): void {
    this.resetSize.emit();
  }
  
  onResizeStart(event: MouseEvent): void {
    this.resizeStart.emit(event);
  }
}
